const groupPrefix = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.EMPLOYEES)
const groupPrefix2 = createApiRoute(ApiModule.AUTH, ApiAuthorization.EMPLOYEE, ApiDataModel.ACCOUNT_STATUS)

export const apiEmployee = {
	updateEmployee: async (employeeUUID: string, obj: Partial<IEmployeeModel>) => {
		const { data } = await apiCommon<IEmployee>(`${groupPrefix}/${employeeUUID}`, {
			method: 'PUT',
			body: employeeToJSON(obj),
		})
		return Employee(data)
	},

	fetchEmployees: async (
		role: EEmployeeRole[] | undefined,
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
	) => {
		const { data, meta } = await apiCommon<IEmployee[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery({ page, perPage }, { role, search }),
		})
		return { data: data.map(d => Employee(d)), meta }
	},

	deleteEmployee: async (employeeUUID: string) =>
		await apiCommon<IEmployee>(`${groupPrefix}/${employeeUUID}`, { method: 'DELETE' }),

	fetchDeactivatedEmployees: async (page: number = 1, perPage: number = 25) => {
		const { data, meta } = await apiCommon<IEmployee[]>(`${groupPrefix}/deactivated`, {
			method: 'GET',
			...createQuery({ page, perPage }),
		})
		return { data: data.map(d => Employee(d)), meta }
	},

	activateEmployee: async (employeeUUID: string) => {
		const { data } = await apiCommon<IEmployee>(`${groupPrefix2}/${employeeUUID}`, {
			method: 'PUT',
			body: { is_active: true },
		})
		return Employee(data)
	},

	deactivateEmployee: async (employeeUUID: string) => {
		const { data } = await apiCommon<IEmployee>(`${groupPrefix2}/${employeeUUID}`, {
			method: 'PUT',
			body: { is_active: false },
		})
		return Employee(data)
	},
}
